import CreateGroupHeader from "./CreateGroupHeader";
import GroupProfileImage from "./GroupProfileImage";
import GroupNameInput from "./GroupNameInput";
import GroupDescriptionInput from "./GroupDescriptionInput";
import GroupMembersList from "./GroupMembersList";
import DoneButton from "./DoneButton";
import { useContactList } from "../../../store/api/useContactList";
import { useAppSelector } from "../../../utils/hooks";
import { useGroupSettings } from "../../../store/api/useGroupSettings";
import TextTranslate from "../../../utils/TextTranslate";

export default function CreateGroupComponent() {
  useContactList();
  const CreateGroup = useAppSelector((state) => state.CreateGroup);
  const { data: groupSettingsData } = useGroupSettings();

  return (
    <div className="relative flex h-[100dvh] w-full flex-col overflow-hidden bg-secondary pb-[calc(3.25rem+env(safe-area-inset-bottom))] shadow-inner lg:max-w-md lg:pb-0">
      <CreateGroupHeader />

      <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-28 pt-4">
        <div className="mb-5 flex flex-col items-center">
          <GroupProfileImage />
        </div>

        <div className="mb-1.5 px-1 text-[13px] font-medium uppercase tracking-wide text-lightText">
          <TextTranslate text="Group Info" />
        </div>
        <div className="mb-5 overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
          <div className="px-3 py-2">
            <GroupNameInput />
          </div>
          <div className="border-t border-black/[0.06] px-3 py-2 dark:border-white/[0.08]">
            <GroupDescriptionInput />
          </div>
        </div>

        <div className="mb-1.5 px-1 text-[13px] font-medium uppercase tracking-wide text-lightText">
          <TextTranslate text="Members" /> · {CreateGroup.user_id.length} /{" "}
          {groupSettingsData?.settings[0].max_members ?? 10}
        </div>
        <div className="overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
          <GroupMembersList />
        </div>
      </div>

      <DoneButton />
    </div>
  );
}
